
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, AlertCircle, Clock, Ban } from 'lucide-react';

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  let variant: 'default' | 'secondary' | 'destructive' | 'outline' = 'default';
  let icon = null;
  let label = status;
  
  switch (status.toLowerCase()) {
    case 'active':
      variant = 'default';
      icon = <CheckCircle className="h-4 w-4 mr-1" />;
      label = 'Actif';
      break;
      
    case 'trialing':
      variant = 'secondary';
      icon = <Clock className="h-4 w-4 mr-1" />;
      label = 'Période d\'essai';
      break;
      
    case 'past_due':
      variant = 'destructive';
      icon = <AlertCircle className="h-4 w-4 mr-1" />;
      label = 'Paiement en retard';
      break;
      
    case 'incomplete':
    case 'incomplete_expired':
      variant = 'destructive';
      icon = <AlertCircle className="h-4 w-4 mr-1" />;
      label = 'Incomplet';
      break;
      
    case 'cancelled':
      variant = 'outline';
      icon = <Ban className="h-4 w-4 mr-1" />;
      label = 'Annulé';
      break;
      
    case 'unpaid':
      variant = 'destructive';
      icon = <AlertCircle className="h-4 w-4 mr-1" />;
      label = 'Impayé';
      break;
      
    case 'pending':
      variant = 'secondary';
      icon = <Clock className="h-4 w-4 mr-1" />;
      label = 'En attente';
      break;
      
    default:
      variant = 'outline';
      label = status;
  }
  
  return (
    <Badge variant={variant} className="flex items-center">
      {icon}
      {label}
    </Badge>
  );
};

export default StatusBadge;
